/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Select_AddressInputs */

const en_checkout_select_address = /** @type {(inputs: Checkout_Select_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Delivery Address`)
};

const es_checkout_select_address = /** @type {(inputs: Checkout_Select_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar Dirección de Entrega`)
};

const fr_checkout_select_address = /** @type {(inputs: Checkout_Select_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner l'adresse de livraison`)
};

const de_checkout_select_address = /** @type {(inputs: Checkout_Select_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieferadresse auswählen`)
};

const id_checkout_select_address = /** @type {(inputs: Checkout_Select_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih Alamat Pengiriman`)
};

/** @type {(inputs: Checkout_Select_AddressInputs) => LocalizedString} */
const ja_checkout_select_address = en_checkout_select_address;

/** @type {(inputs: Checkout_Select_AddressInputs) => LocalizedString} */
const zh_checkout_select_address = en_checkout_select_address;

/** @type {(inputs: Checkout_Select_AddressInputs) => LocalizedString} */
const ar_checkout_select_address = en_checkout_select_address;

/** @type {(inputs: Checkout_Select_AddressInputs) => LocalizedString} */
const it_checkout_select_address = en_checkout_select_address;

/** @type {(inputs: Checkout_Select_AddressInputs) => LocalizedString} */
const ru_checkout_select_address = en_checkout_select_address;

/** @type {(inputs: Checkout_Select_AddressInputs) => LocalizedString} */
const pt_checkout_select_address = en_checkout_select_address;

/** @type {(inputs: Checkout_Select_AddressInputs) => LocalizedString} */
const ko_checkout_select_address = en_checkout_select_address;

/**
* | output |
* | --- |
* | "Select Delivery Address" |
*
* @param {Checkout_Select_AddressInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const checkout_select_address = /** @type {((inputs?: Checkout_Select_AddressInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Select_AddressInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkout_select_address(inputs)
	if (locale === "es") return es_checkout_select_address(inputs)
	if (locale === "fr") return fr_checkout_select_address(inputs)
	if (locale === "de") return de_checkout_select_address(inputs)
	if (locale === "ja") return ja_checkout_select_address(inputs)
	if (locale === "zh") return zh_checkout_select_address(inputs)
	if (locale === "ar") return ar_checkout_select_address(inputs)
	if (locale === "id") return id_checkout_select_address(inputs)
	if (locale === "it") return it_checkout_select_address(inputs)
	if (locale === "ru") return ru_checkout_select_address(inputs)
	if (locale === "pt") return pt_checkout_select_address(inputs)
	return ko_checkout_select_address(inputs)
});